import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { AutomaticBillRunDto } from 'ts-types/api.types';
import axios, { CancelTokenSource } from 'axios';
import LoaderComponent from 'components/LoaderComponent';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import { withAuthContext } from 'auth/AuthContext';
import { getAutomaticBillRunById } from 'services/billServices';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import AutomaticBillDetails from 'components/automatic-billiing/segments/AutomaticBillDetails';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';

const StyledPraxSegment = styled(PraxStyledSegment)`
  margin: 0 !important;
`;

const VerticalFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

interface RouteParams {
  runId: string
}

interface Props extends MessageSourceProps, RouteComponentProps<RouteParams> {
}

interface State {
  pageDataLoaded: boolean,
  runId?: number,
  automaticBillRun?: AutomaticBillRunDto,
  headerMessage: string,
  errorMessage?: string,
  cancelTokenSource: CancelTokenSource,
}

class AutomaticBillHistoryOverview extends Component<Props, State> {

  private mounted: boolean = false;

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();
    const {getMessage} = props;

    const runId = Number(this.props.match.params.runId);
    this.state = {
      pageDataLoaded: false,
      runId: runId,
      automaticBillRun: undefined,
      headerMessage: getMessage("automaticBilling.automaticBillingHistory"),
      cancelTokenSource
    };

    const onFinally = () => {
      this.setState({
        pageDataLoaded: true
      })
    };

    getAutomaticBillRunById(runId, cancelTokenSource)
        .then(response =>
            this.setState({
              automaticBillRun: response
            })
        )
        .catch(() => {this.setErrorMessage(getMessage("error.general"));})
        .finally(onFinally);
  }

  componentDidMount(): void {
    this.mounted = true;
  }

  componentWillUnmount(): void {
    this.mounted = false;

    const {cancelTokenSource} = this.state;
    cancelTokenSource && cancelTokenSource.cancel('Operation canceled by user');
  };

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    })
  };

  goToAutomaticBilling = () => {
    const {history} = this.props;
    history.push("/automatic-billing/run-data");
  };

  setHeaderMessage = (message: string) => {
    const {headerMessage} = this.state;
    this.setState({
      headerMessage: headerMessage + message
    })
  };

  render(): React.ReactNode {
    const {pageDataLoaded, headerMessage, errorMessage} = this.state;
    const {getMessage} = this.props;

    return (
        <VerticalFlexDiv>
          <FullScreenPageHeader headerMessage={headerMessage}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToAutomaticBilling()}/>

          <StyledPraxSegment>
            {errorMessage
            && (
                <StyledErrorMessage onDismiss={() => this.setErrorMessage()} style={{margin: 0}}>
                  {errorMessage}
                </StyledErrorMessage>
            )
            }
            {!pageDataLoaded
                ? <LoaderComponent message={getMessage("automaticBilling.runLoader")}/>
                : this.renderRunDetails()}
          </StyledPraxSegment>
        </VerticalFlexDiv>

    );
  }

  renderRunDetails = (): JSX.Element => {

    const {runId, automaticBillRun} = this.state;
    return (
        <AutomaticBillDetails
            automaticBillRun={automaticBillRun}
            runId={runId}
            onClose={() => {}}
            setHeaderMessage={this.setHeaderMessage}
            setErrorMessage={this.setErrorMessage}
        />
    );
  };

}

export default withAuthContext(withRouterWorkaround(withMessages(AutomaticBillHistoryOverview)));
